import { capitalizeString } from '@/utils/capitalizeString';

export function convertTypeToString(string: string | null) {
  let typeString = capitalizeString(string);
  return (typeString = typeString.replace(/_/g, ' '));
}
